import Layout from '@/layout/layout'

const evisaManagementRouter = {
  path: '/evisaManagement',
  component: Layout,
  redirect: 'noRedirect',
  name: '电子签管理',
  children: [
    {
      path: 'signatureTemplate',
      component: () => import('@/views/evisaManagement/signatureTemplate/index.vue'),
      name: '签署模版',
      meta: { title: '签署模版', noCache: true }
    },
    {
      path: 'createSignature',
      component: () => import('@/views/evisaManagement/createSignature/index.vue'),
      name: '创建签署任务',
      meta: { title: '创建签署任务', noCache: true }
    },
    {
      path: 'signatureTask',
      component: () => import('@/views/evisaManagement/signatureTask/index.vue'),
      name: '签署任务管理',
      meta: { title: '签署任务管理', noCache: true }
    },
    {
      path: 'signatureTemplateDetail',
      component: () => import('@/views/evisaManagement/signatureTemplateDetail/index.vue'),
      name: '签署模板详情',
      meta: { title: '签署模板详情', noCache: true }
    },
    {
      path: 'createSignaturedetial',
      component: () => import('@/views/evisaManagement/createSignature/detial.vue'),
      name: '签署任务详情',
      meta: { title: '签署任务详情', noCache: true }
    },
  ]
}

export default evisaManagementRouter
